import { CardAPI, GeorgeBusinessAPI, NetbankingAPI } from "aaa";
import { CardAPIClient, GeorgeBusinessAPIClient, NetbankingAPIClient } from "network/APIClient";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

// All differentiation between George Retail and George Business should ideally be done here
class GeorgeBusinessAdapter {

    // ATTENTION: get netbankingApiClient() and get cardApiClient() will only work as long as all calls to
    // NetbankingAPI or CardAPI use the same client.
    //
    // If you have e.g. 2 calls A and B 
    // where A uses CardAPI on retail and GeorgeBusinessAPI on business
    // and B uses CardAPI on retail and GeorgBusinessSomeOtherAPI on business
    // you will have to differentiate between the clients in the calls to A and B and CANNOT use get cardApiClient()

    get netbankingApiClient() {
        return externalInterfaceStore.isGeorgeBusiness ? GeorgeBusinessAPIClient : NetbankingAPIClient;
    }

    get cardApiClient() {
        return externalInterfaceStore.isGeorgeBusiness ? GeorgeBusinessAPIClient : CardAPIClient;
    }

    async getCard(cardId: string) {
        const target = externalInterfaceStore.isGeorgeBusiness ? GeorgeBusinessAPI.getCard(cardId) : NetbankingAPI.getCard(cardId);
        return this.netbankingApiClient.requestType(target);
    }

    async getCards(filterFor?: string) {
        const target = externalInterfaceStore.isGeorgeBusiness ? GeorgeBusinessAPI.getCards(filterFor) : NetbankingAPI.getCards(filterFor);
        return this.netbankingApiClient.requestType(target);
    }

    // George business API, but used by retail -> no if statement to differentiate the two cases
    async matchInvitation(invitationId: string) {
        const target = GeorgeBusinessAPI.postInvitationsMatch(invitationId);
        return GeorgeBusinessAPIClient.requestType(target);
    }

    async getLoyalty(cardId: string) {
        const target = externalInterfaceStore.isGeorgeBusiness ? GeorgeBusinessAPI.getLoyalty(cardId) : CardAPI.getLoyalty(cardId);
        return this.cardApiClient.requestType(target);
    }

    async getPayCardFeeInMilesDetail(cardId: string) {
        const target = externalInterfaceStore.isGeorgeBusiness
            ? GeorgeBusinessAPI.getPayCardFeeInMilesDetail(cardId)
            : CardAPI.getPayCardFeeInMilesDetail(cardId);
        return this.cardApiClient.requestType(target);
    }

    async putPayCardFeeInMiles(
        cardId: string,
        body: { payCardsFeeInMilesActivated: boolean }
    ) {
        const target = externalInterfaceStore.isGeorgeBusiness
            ? GeorgeBusinessAPI.putPayCardFeeInMiles(cardId, body)
            : CardAPI.putPayCardFeeInMiles(cardId, body);
        return this.cardApiClient.requestType(target);
    }

    async getSettings() {
        if (externalInterfaceStore.isGeorgeBusiness) {
            const target = GeorgeBusinessAPI.getSettings();
            return GeorgeBusinessAPIClient.requestType(target);
        } else {
            const target = NetbankingAPI.getSettings();
            return NetbankingAPIClient.requestType(target);
        }
    }
}

export const gba = new GeorgeBusinessAdapter();



// WEBPACK FOOTER //
// ./src/util/georgeBusinessAdapter.ts